import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Info from '../../Info';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';


// Import utilities
import { tailwindConfig } from '../../../utils/Utils';

function TopTimelineCard({title, category, data, hint}) {

  const [patternIndex, setPatternIndex] = useState(0)
  const [listItems, setListItems] = useState([])

  function updatePattern(direction){
    if(direction=='forward') {
      if (patternIndex == 9)
        setPatternIndex(0)
      else
        setPatternIndex(patternIndex + 1)
    }
    if(direction=='back'){
      if (patternIndex == 0)
        setPatternIndex(9)
      else
        setPatternIndex(patternIndex - 1)
    }
  }

  useEffect(() => {
    if(data.length>0)
      setListItems(data[patternIndex].map((item, index)=>{
        return (
          <TimelineItem key={index}>
            <TimelineOppositeContent color="bg-slate-300">
              {item}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot sx={{ bgcolor: '#F53F85' }} />
              {index < (data[patternIndex].length-1) ? <TimelineConnector sx={{ bgcolor: '#F98EB7' }} />:''}
            </TimelineSeparator>
            <TimelineContent>🔔</TimelineContent>
          </TimelineItem>
        );
      }))
  }, [data, patternIndex]);

  return (
    <div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 lg:w-72 xl:w-80">
      <header className="px-5 py-4 border-b border-slate-100 flex items-center">
        <h2 className="font-semibold text-slate-800">{title}</h2>
        <Info className="ml-auto" containerClassName="min-w-80">
          <div className="text-sm">{hint}</div>
        </Info>
      </header>
      <div className="flex justify-between mt-4 mb-4">
        <button className="btn-xs bg-gray-400 hover:bg-gray-500 text-white" onClick={()=>updatePattern('back')}>Back</button>
        <p>#{patternIndex+1}</p>
        <button className="btn-xs bg-gray-400 hover:bg-gray-500 text-white" onClick={()=>updatePattern('forward')}>Next</button>
      </div>
      <Timeline position="alternate">
        {listItems.length>0?listItems:
            <div className="m-auto text-center mb-2">
                <svg className="animate-spin h-5 w-full" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="6" fill="transparent" strokeLinecap="round"
                            strokeDasharray="283" strokeDashoffset="75"/>
                </svg>
            </div>
        }
      </Timeline>
    </div>
  );
}

export default TopTimelineCard;
